import { MetaDocument } from "./meta.generated";
export class MetaQueryHandler {
    async get(subgraphClient, query) {
        const response = await subgraphClient.request(MetaDocument, query);
        if (!response._meta) {
            return null;
        }
        return {
            blockNumber: response._meta.block.number,
            blockHash: response._meta.block.hash,
            deployment: response._meta.deployment,
            hasIndexingErrors: response._meta.hasIndexingErrors,
        };
    }
}
